import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
} from "recharts";

// #endregion
const StoreRadarChart = ({ performance_radar }) => {
  const data = [
    {
      subject: "الطلبات",
      A: performance_radar?.orders,
    },
    {
      subject: "التقييم",
      A: performance_radar?.rating,
    },
    {
      subject: "الربح",
      A: performance_radar?.profit,
    },
    {
      subject: "السرعة",
      A: performance_radar?.speed,
    },
    {
      subject: "الجودة",
      A: performance_radar?.quality,
    },
  ];
  return (
    <div className="card rounded-4">
      <div className="card-body">
        <h6>مقاييس الأداء المتوسط</h6>
        <RadarChart
          style={{
            width: "100%",
            height: "100%",
            maxHeight: "40vh",
            aspectRatio: 1,
          }}
          responsive
          outerRadius="80%"
          data={data}
          margin={{
            top: 20,
            left: 20,
            right: 20,
            bottom: 20,
          }}
        >
          <PolarGrid />
          <PolarAngleAxis dataKey="subject" />
          <PolarRadiusAxis />
          <Radar
            name="الأداء"
            dataKey="A"
            stroke="#FFCC03"
            fill="#FFCC03"
            fillOpacity={0.5}
          />
        </RadarChart>
      </div>
    </div>
  );
};

export default StoreRadarChart;
